const floorPlans = [
  'ワンルーム',
  '1K',
  '1DK',
  '1LDK',
  '2K',
  '2DK',
  '2LDK',
  '3K',
  '3DK',
  '3LDK',
  '4K',
  '4DL',
  '4LDK',
  '5LDK',
]

const structures = [
  '木造',
  '鉄骨造',
  '鉄筋コンクリート造',
  '鉄骨鉄筋コンクリート造',
  'アルミ造',
  'コンクリート充填鋼管構造',
  'コンクリートブロック造',
]

export const groups: Record<string, string> = {}
export const groupLabels = ['Layout', 'Structure', 'Features']

floorPlans.forEach((key) => (groups[key] = 'Layout'))
structures.forEach((key) => (groups[key] = 'Structure'))

export const listLabels = [
  '事務所',
  '店舗',
  '売地',
  '投資用',
  'オーナーチェンジ',
  '空室',
  '賃貸中',
  '新築',
  '借地',
  'オープンルーム',
  'ペット可',
  'SOHO使用可',
]
